import { MtWorkGenerationInfo } from './MtWorkGenerationInfo';

export enum WorkState {
  geplant = 0,
  anstehend = 1,
  beauftragt = 2,
  teilerledigt = 3,
  erledigt = 4,
}

export class WorkWizardOptions {
  objectInfos: MtWorkGenerationInfo[] = [];
  state?: WorkState;
  workTypeId?: string;
  executeEarliest?: Date;
  executeLatest?: Date;
  scheduledExecutionDate?: Date;
  execTimeInDays?: number;

  workGeneratorMode: WorkGeneratorMode = WorkGeneratorMode.manual;
  orderId?: string;
  source?: string;
}

export enum WorkGeneratorMode {
  cyclic = 'cyclic',
  manual = 'manual',
  availableWorks = 'availableWorks',
}

export enum WorkAuftragMode {
  none = 'none',
  useExisting = 'useExisting',
  createNew = 'createNew',
}

export enum WorkGroupsConfigMode {
  evaluate = 'evaluate',
  createNew = 'createNew',
  editExisting = 'editExisting',
}

export interface CyclicWorkGenerationResult {
  WorkTypeId: string;
  Success: boolean;
  Data?: any;
  Error?: any;
}
export interface PersistenceResult {
  affectedCount: number;
  success: boolean;
  error?: any;
}
